import { render, staticRenderFns } from "./OrderEdit.vue?vue&type=template&id=0ceed52e&scoped=true&"
import script from "./OrderEdit.vue?vue&type=script&lang=js&"
export * from "./OrderEdit.vue?vue&type=script&lang=js&"
import style0 from "./OrderEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrderEdit.vue?vue&type=style&index=1&id=0ceed52e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ceed52e",
  null
  
)

export default component.exports